import { Loader2 } from "lucide-react";
import { Heading, Subheading } from "../../../components/catalyst/Heading";

export function LoadingState() {
	return (
		<>
			<Heading>Connecting to Stripe...</Heading>
			<Subheading>Please wait while we redirect you.</Subheading>
			<Loader2 className="block h-8 w-8 animate-spin text-base-content" />
		</>
	);
}
